import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/291'

const LifecycleFunnelByLocationTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="activation_rate.tabs.lifecycle_funnel_by_location"
  />
)

export default LifecycleFunnelByLocationTab
